<template>
  <div>
    <div class="panel panel-default col-md-12">
      <div class="panel-heading">
        <span style="font-weight: 700" class="text-uppercase">PRODUKTLINK {{ index + 1 }}</span>
        <div style="float:right">
          <button type="button" class="btn btn-sm btn-default" style="float:right; border: 0" @click="removeMark"
                  content="Produktlink löschen" v-tippy>
            <i class="fa fa-close" style="color: black"></i>
          </button>
        </div>
      </div>
      <div class="panel-body">
        <div class="form-group">
          <label>Link</label>
          <input type="text"
                 class="form-control"
                 v-model="record.link_external">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../common/modal/Modal";
import VueToastr from "vue-toastr";
import Spinner from "../common/spinner/Spinner";

export default {
  name: 'AdvertisementMark',
  components: {
    Spinner,
    Modal,
    VueToastr
  },
  methods: {
    submit() {
      this.$emit('submit', this.record)
    },
    removeMark() {
      this.page.marks.splice(this.index, 1);

      this.$forceUpdate();
      this.$parent.$forceUpdate();
    },
  },
  props: ['record', 'page', 'index'],
  mounted() {
    this.$parent.$forceUpdate();
    this.$forceUpdate();
  }
}
</script>

<style scoped>
</style>
<style>
.ckeditor-wrapper .ck-content {
  min-height: 300px;
}
</style>
